import { makeStyles } from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import OTPInput from "react-otp-input";
import { convertAllNumbersToEnglish } from "components/PaymentProduct/utils";

const useStyles = makeStyles(theme => ({
  input: {
    border: props => (props.error ? "1px solid #FF5252" : "1px solid #E5E9FA"),
    borderRadius: "12px",
    width: "66px !important",
    height: "60px !important",
    fontSize: "30px",
    color: "#000",
    fontWeight: "500",
    caretColor: "#7E77EB",
    lineHeight: "52.73px",
    position: "relative",
    zIndex: 2,

    [theme.breakpoints.down("xs")]: {
      width: "57px !important",
      height: "52px !important",
      fontSize: "26px",
    },
  },
  inputFocused: {
    border: "1px solid #CFD3DB",
    outline: "none",
  },
}));

function OtpAuth({ code, handleChange, numInputs, error, onComplete }) {
  const classes = useStyles({ error });
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    // Only trigger if code is complete and hasn't been sent yet
    if (code.length === numInputs && onComplete && !hasCompletedRef.current) {
      hasCompletedRef.current = true;
      onComplete(code);
    }
    // Reset the ref when the code changes to an incomplete state
    if (code.length !== numInputs) {
      hasCompletedRef.current = false;
    }
  }, [code, numInputs, onComplete]);

  const handleOtpChange = (value) => {
    // Convert Persian digits to English and filter out non-numeric characters
    const convertedValue = convertAllNumbersToEnglish(value).replace(/[^0-9]/g, '');
    handleChange(convertedValue);
  };

  return (
    <div style={{ direction: "ltr", marginTop: 16 }}>
      <OTPInput
        value={code}
        onChange={handleOtpChange}
        numInputs={numInputs}
        renderSeparator={<span style={{ width: "8px" }}></span>}
        renderInput={props => (
          <input 
            {...props} 
            inputMode="numeric"
            onKeyPress={(e) => {
              // Allow only Persian digits (۰-۹) and English digits (0-9)
              const allowedChars = /[۰-۹0-9]/;
              if (!allowedChars.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        )}
        shouldAutoFocus={true}
        inputStyle={classes.input}
        focusStyle={classes.inputFocused}
      />
    </div>
  );
}

export default OtpAuth;